
import CourseDescription from './CourseDescription.vue';

export default {
  components: { CourseDescription },
  data() {
    return {
      expandAll: false,
      expandedPanels: [],
      courseSections: [
        { title: "Get the Most from this course", time: "10 lectures • 49min" },
        { title: "PMBOK Guide, Sixth Edition", time: "12 lectures • 1hr 15min" },
        { title: "Define Project Management Foundations", time: "8 lectures • 40min" },
        { title: "Related Areas of Project Management", time: "15 lectures • 1hr 30min" },
        { title: "Project Management Components", time: "7 lectures • 35min" },
        { title: "Project Environments", time: "9 lectures • 50min" },
        { title: "Role of the Project Manager", time: "10 lectures • 55min" },
        { title: "Implementing Project Integration Management", time: "11 lectures • 1hr 5min" },
        { title: "Managing the Project Scope", time: "13 lectures • 1hr 10min" },
      ]
    };
  },
  methods: {
    toggleExpandAll() {
      this.expandAll = !this.expandAll;
      this.expandedPanels = this.expandAll
        ? this.courseSections.map((_, index) => index)
        : [];
    }
  }
};
